<script>
    import {_} from '../lib/i18n';
    export let params;
    export let analyze;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let isFreeTrialExpired = false;
    $: isFreeTrialExpired  = !params.identity.isActiveFreeAccessTrial();

    import {navigate} from "svelte-routing";

    let isFinished = false;
    $: analyze && (isFinished = analyze.checkIsFinished());

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }
</script>
{#if isFinished}
<section class="free-access-alert">
    {#if (!isFreeTrialExpired)}
        <p class="free-access-alert__title">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.75 13V8.5M1.75 8.5V1H12.25L9.25 4.75L12.25 8.5H1.75Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {$_('freeAccessAlert.title')}
        </p>
        <p class="free-access-alert__body">
            {$_('freeAccessAlert.expiredDescription1')}
        </p>
        <p class="free-access-alert__body">
            {$_('freeAccessAlert.expiredDescription2')}
        </p>
        <button on:click={gotoTariffs}  class="button button_shadow ">
            {$_('freeAccessAlert.selectPlanBtnLabel')}
        </button>
    {:else}
        <p class="free-access-alert__title">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.75 13V8.5M1.75 8.5V1H12.25L9.25 4.75L12.25 8.5H1.75Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {$_('freeAccessAlert.continueMonitoringBtnLabel')}
        </p>
        <p class="free-access-alert__body">
            {$_('freeAccessAlert.continueMonitoringDescription')}
        </p>
        <button on:click={gotoTariffs}  class="button button_shadow ">
            {$_('freeAccessAlert.selectPlanBtnLabel')}
        </button>
    {/if}
</section>
{/if}
<style>
.free-access-alert {
    border-radius: 6px;
    border: 1px solid #74C733;
    display: flex;
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}
.free-access-alert__title {
    font-weight: 700;
}
.free-access-alert__body {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
}
</style>